import { defineComponent } from 'vue';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import axios, { AxiosResponse } from 'axios';

import { ShareConfApi2ViewModel, configblobshare, dccore_shareconfiguser} from "./../../Scripts/js/detecterconfig";
import { createPinia } from 'pinia';

const mixin = defineComponent({
    data() {
        return {
            viewmodel: null as ShareConfApi2ViewModel | null,
            mapusername: null as any,
            mapconfig: null as any
        }
    },
    mounted() {
        this.SettingsShare();
    },
    methods: {
        SettingsShare() {
            let url: string = "/api/v1.0/shareconfig/SettingsShare";
            let self = this;
            axios.get<ShareConfApi2ViewModel>(url).then(function (response: AxiosResponse<ShareConfApi2ViewModel>) {
                if (response !== null)
                    if (response.data) {
                        self.viewmodel = response.data;
                        self.mapusername = new Map(self.viewmodel.m_usernamedict.map(key => [key.id, key.name] as [number, string]) );
                        self.mapconfig = new Map(self.viewmodel.m_configdict.map(key => [key.id, key.configusers] as [number, dccore_shareconfiguser[]]) );
                    }
            });
        },
        DeletePublicShare(config: configblobshare) {
            let url: string = "/api/v1.0/shareconfig/DeletePublicShare?idconfig=" + config.idnum;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response !== null)
                    if (response.data) {
                        config.sharepublishall = false;
                        self.SettingsShare();
                    }
            });
        },
        DeleteUserShare(config: configblobshare, idmember: number) {
            let url: string = "/api/v1.0/shareconfig/DeleteUserShare?idconfig=" + config.idnum + "&idmember=" + idmember;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response !== null)
                    if (response.data) {
                        if (self.mapconfig != null && (self.mapconfig.get(config.idnum) != null)) {
                            let members: number[] = (self.mapconfig.get(config.idnum) as number[]).filter(f => f !== idmember);
                            self.mapconfig.set(config.idnum, members);
                        }
                        self.SettingsShare();
                    }
            });
        },

        EnablePublicShare(config: configblobshare) {
            let url: string = "/api/v1.0/shareconfig/EnablePublicShare?idconfig=" + config.idnum+"&levelsecu=";
            let self = this;
            axios.post<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response !== null)
                    if (response.data) {
                        config.sharepublishall = true;
                        self.SettingsShare();
                    }
            });
        },
        SwitchPublicShare(config: configblobshare, enable: boolean) {
            if (enable)
                this.EnablePublicShare(config);
            else
                this.DeletePublicShare(config);

        }
    }
});


export class ShareSettingsConfigComponent {
   
    public Init() {
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).ShareSettingsConfigComponent = function () { return new ShareSettingsConfigComponent(); };